import { ref, onMounted, onUnmounted } from 'vue';

// Tailwind's `md` starts at 768px, so 768 (an iPad in portrait) is desktop here too. That keeps a
// layout chosen by this flag in step with its `max-md:` rules. sidebar.store.js uses the same cutoff.
const MOBILE_MAX_WIDTH = 767;

// For code outside a component, such as a store, that needs the answer once rather than a live ref.
export const isMobileViewport = () => window.innerWidth <= MOBILE_MAX_WIDTH;

export function useIsMobile() {
	const isMobile = ref(isMobileViewport());

	const handleResize = () => {
		isMobile.value = isMobileViewport();
	};

	onMounted(() => {
		window.addEventListener('resize', handleResize);
	});

	onUnmounted(() => {
		window.removeEventListener('resize', handleResize);
	});

	return { isMobile };
}
